<template>
  <div class="button-nav">
    <div class="wrapper">
      <div
        class="button-holder"
        v-for="btn in buttons"
        :key="btn.name">

        <div class="notification-tooltip-helper">
          <input-button
            :inputPlaceholder="btn.label"
            :conformation="btn.confirm"
            smaller
            pointable
            :btnStyle="getBtnStyle(btn)"
            :dissabled="isDisabled(btn)"
            @click="emitEvent(btn.event, true)"
            variant="standardInput"
            :iconLeft="getLeftIcon(btn)"
            :iconRight="getRightIcon(btn)"
            :faIcon="btn.faIcon"
            :hollow="btn.hollow"
            :iconColor="btn.iconColor" />

          <div
            v-if="getTooltopLabel(btn.name)"
            class="notification"
            v-html="getTooltopLabel(btn.name)" />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputButton from '@/components/standard/input/InputButton'

export default {
  methods: {
    /**
     * Gives tooltip label for button if any specified
     * @param {String} name
     * @returns {*}
     */
    getTooltopLabel (name) {
      if (!this.tooltips[name]) return false

      return this.tooltips[name].join('; ')
    },

    /**
     * Receives a button object, returnes it's left icon
     * @param {Object} btn Button object
     * @returns {*} Icon name or null
     */
    getLeftIcon (btn) {
      if (this.disable[btn.name]) return null
      return btn.iconLeft || null
    },

    /**
     * Receives a button object, returnes it's right icon
     * @param {Object} btn Button object
     * @returns {*} Icon name or null
     */
    getRightIcon (btn) {
      if (this.disable[btn.name]) return null
      return btn.iconRight || null
    },

    /**
     * Tells if the button is disabled
     * @prop {Object} btn Button object
     * @returns {Boolean} If the button is disabled
     */
    isDisabled (btn) {
      return !!(this.disable[btn.name])
    },

    getBtnStyle (btn) {
      return btn.style || 'ok-style'
    },
    emitEvent (name, value) {
      this.$emit(name, {value})
    }
  },
  props: {
    disable: {
      type: Object,
      required: false,
      default: () => {return {}}
    },
    buttons: {
      type: Array,
      required: true,
      default: () => []
    },
    tooltips: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },
  components: {
    'input-button': InputButton
  }

}
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap-reverse;
}
.button-nav {
  overflow-x: scroll;
}
.button-nav::-webkit-scrollbar { 
  display: none;
}
.button-holder {
  margin: 5px 0px 5px 11px;
  display: inline-block;
  transition: border-bottom .3s, color .3s;
}

.active {
  border-bottom: 2px solid #7AC143;
}
.active a {
  color: #353635!important;
}
.notification {
  position: absolute;
  z-index: 100;
  width: 200px;
  right: 0;
  text-align: right;
  background-color: #FFFFFF;
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 12px;
  font-weight: lighter;
  margin-top: 5px;
  display: none;
  border: 1px solid #353635;
}

.notification-tooltip-helper:hover >  .notification {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/standard/action/ButtonNav.vue?4369d9b2